import type { ProgramListEvent } from 'models';
import { getLastChangeRequestStatus } from '../../utils';
import { EventActionsSocial } from '../event-actions-social';
import { EventChangeRequestStatusTag } from '../event-change-request-status-tag';

type P = {
  authorId?: string;
  event: Omit<ProgramListEvent, 'author'>;
};

const EventSocialContent = ({ authorId, event }: P) => {
  const { changeRequests, startTime, status } = event;

  if (status === 'draft') {
    return <EventChangeRequestStatusTag startTime={startTime} status={getLastChangeRequestStatus(changeRequests)} />;
  }

  return <EventActionsSocial authorId={authorId} event={event} hasLabel />;
};

export default EventSocialContent;
